import React from 'react'
import cn from 'classnames'

interface StickyControlledProps {
  show?: boolean
  placement?: string
  offset?: number
  className?: string
  children: React.ReactElement
  role?: string
  ariaLabel?: string
  /** Forwarded to the fixed root so callers can measure the bar's height. */
  ref?: React.Ref<HTMLDivElement>
}

const StickyControlled = ({
  show = false,
  placement = 'bottom',
  offset = 0,
  className,
  children,
  ariaLabel,
  role,
  ref,
}: StickyControlledProps) => {
  const classes = cn({
    'mc-sticky': true,
    [`mc-sticky--${placement}`]: true,
    'mc-sticky__show': show,
    [className ?? '']: !!className,
  })

  return (
    <div
      ref={ref}
      className={classes}
      style={{ [placement]: `${offset}px` }}
      aria-label={ariaLabel}
      role={role}
    >
      {children}
    </div>
  )
}

export default StickyControlled
